import { WORKFLOW_KEYS } from '../../keys';

export const rpaUserWorkflowsQueryKey = ['rpa-user-workflows'] as const;

/** Rooted under the routine family: the recorded steps are a recorded routine's
 * body, so a chat `update_routine` result (which invalidates `['workflows']`)
 * refreshes them. Form saves invalidate only routine lists; they cannot change
 * the steps. */
export function rpaSkillWorkflowDetailQueryKey(recordingId: string) {
  return [...WORKFLOW_KEYS.all, 'recorded-steps', recordingId] as const;
}
